const NAMES = [
  'María',
  'Sofía',
  'Carmen',
  'Isabella',
  'Camila',
  'Valentina',
  'Lucía',
  'Daniela',
  'Patricia',
  'Marcela',
  'Andrea',
  'Gabriela',
  'Beatriz',
  'Carolina',
  'Adriana',
  'Mónica',
  'Verónica',
  'Roxana',
  'Alejandra',
  'Paula',
  'Diana',
  'Claudia',
  'Silvia',
  'Mariana',
  'Cristina',
  'Elena',
  'Teresa',
  'Esperanza',
  'Pilar',
  'Olga',
  'Yolanda',
  'Rosario',
  'Lorena',
  'Margarita',
  'Sandra',
  'Liliana',
  'Linda',
  'Sarah',
  'Jennifer',
  'Michelle',
  'Rebecca',
  'Karen',
  'Jessica',
  'Amanda',
  'Nicole',
]

const CITIES = [
  'Miami, FL',
  'Houston, TX',
  'Los Angeles, CA',
  'San Antonio, TX',
  'Phoenix, AZ',
  'Dallas, TX',
  'New York, NY',
  'Chicago, IL',
  'San Diego, CA',
  'Orlando, FL',
  'Tampa, FL',
  'Austin, TX',
  'El Paso, TX',
  'Albuquerque, NM',
  'Denver, CO',
  'San Jose, CA',
  'Fresno, CA',
  'Sacramento, CA',
  'Las Vegas, NV',
  'Tucson, AZ',
  'Jacksonville, FL',
  'Charlotte, NC',
  'Atlanta, GA',
  'Boston, MA',
  'Philadelphia, PA',
  'Washington, DC',
  'Newark, NJ',
  'Hialeah, FL',
  'McAllen, TX',
  'Brownsville, TX',
]

// Rolling history of last names used (avoid immediate repeats)
const recentNames: string[] = []
const HISTORY_SIZE = 10

export function pickName(): string {
  const available = NAMES.filter((n) => !recentNames.includes(n))
  const pool = available.length > 0 ? available : NAMES
  const name = pool[Math.floor(Math.random() * pool.length)]
  recentNames.push(name)
  if (recentNames.length > HISTORY_SIZE) recentNames.shift()
  return name
}

export function pickCity(): string {
  return CITIES[Math.floor(Math.random() * CITIES.length)]
}
